export const defaultValues = {
  tiktokPixelId: "",
  whatsappScript: "",
  facebookPixelId: "",
  snapchatPixelId: "",
  twitterWebsiteTag: "",
  tiktokCatalogLink: "",
  tiktokAccessToken: "",
  hotjarScriptHeader: "",
  facebookCatalogLink: "",
  snapchatCatalogLink: "",
  facebookAccessToken: "",
  snapchatAccessToken: "",
  googleTagManagerHead: "",
  googleTagManagerBody: "",
  conversationIdentifier: "",
  googleStatisticsIdentifier: "",
  activateSnapchatPixel: false,
  activateMetaPixel: false,
  activateTikTokPixel: false,
  activateTwitterPixel: false,
};
